import GroupNodeSourceAdditionalInfo from "Areas/SharedFeatures/types/groupNodeSourceAdditionalInfo";
import head from "lodash/head";
import map from "lodash/map";
import nodeSourceFactory from "../utils/nodeOrEdgeSourceDataHandling/nodeSourceFactory";
class GroupNodesSource extends GroupNodeSourceAdditionalInfo {
    constructor(GroupId, Nodes, DocumentObjects, NodeWidth, NodeHeight, GroupName, GroupObjectCount) {
        var _a, _b;
        super(DocumentObjects, (_a = head(Nodes)) === null || _a === void 0 ? void 0 : _a.Created, undefined, undefined, NodeWidth, NodeHeight);
        this.GroupId = GroupId;
        this.Nodes = map(Nodes, n => {
            const item = nodeSourceFactory(n, DocumentObjects);
            item.GroupId = this.GroupId;
            item.PinnedToGroup = true;
            return item;
        });
        this.GroupName = GroupName;
        this.GroupObjectCount = GroupObjectCount;
        this.Created = (_b = head(this.Nodes)) === null || _b === void 0 ? void 0 : _b.Created;
    }
}
export default GroupNodesSource;
